export type JiraIssueItemContent = {
  readonly key: string;
  readonly issueKey: string;
  readonly resolved: boolean;
  readonly authenticationUrl: string | undefined;
  readonly summary: string | undefined;
  readonly url: string | undefined;
  readonly type: string | undefined;
  readonly typeIconUrl: string | undefined;
  readonly statusName: string | undefined;
  readonly statusCategory: 'to-do' | 'in-progress' | 'done' | undefined;
};

/**
 * Immutable Jira Issue presentation in value order.
 */
export type JiraIssueReadContent = {
  readonly kind: 'jira-issue';
  readonly issues: readonly JiraIssueItemContent[];
};

export const EMPTY_JIRA_ISSUE_CONTENT: JiraIssueReadContent = Object.freeze({
  kind: 'jira-issue',
  issues: Object.freeze([])
});
